import Enum from '@square/dashboard-utilities/utils/enum';
export default new Enum(['CASUAL', 'CHURN_RISK', 'EVERYONE', 'LOYAL', 'ROLODEX', 'TESTING', 'REACHABLE', 'LOYALTY_CLOSE_TO_REWARD', 'LOYALTY_ALL', 'ORGANIZATION', 'ALIAS']);